import { jsx, Fragment } from "react/jsx-runtime";
import { Component } from "react";
import { useErrorBoundary } from "./error-boundary.provider.js";
class ErrorClass extends Component {
  state = { hasError: false };
  constructor(props) {
    super(props);
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    if (this.props.onLog) this.props.onLog(error, info);
  }
  render() {
    if (this.state.hasError) {
      return /* @__PURE__ */ jsx(Fragment, { children: this.props.fallback || "" });
    }
    return /* @__PURE__ */ jsx(Fragment, { children: this.props.children });
  }
}
const ErrorBoundary = (props) => {
  const { onLog } = useErrorBoundary();
  const { onLog: customOnLog, ...inProps } = props;
  function handleLog(error, info) {
    onLog(error, info);
    if (customOnLog) customOnLog(error, info);
  }
  return /* @__PURE__ */ jsx(ErrorClass, { ...inProps, onLog: handleLog });
};
export {
  ErrorBoundary
};
//# sourceMappingURL=error-boundary.component.js.map
